<!-- footer.component.html -->
<!-- Mobile Footer (image-style) -->
<div class="block md:hidden">
  <footer class="text-black py-8" style="background-color: #C9DFF7;">
    
    <div class="w-full mx-auto px-2 sm:px-12 relative">
      <svg xmlns="http://www.w3.org/2000/svg" width="100" height="178" viewBox="0 0 100 178" fill="none" class="t-image">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M64 0H0V56V178H64V56H100V0H64Z" fill="#307FE1" stroke="#307FE1" />
      </svg>
      <div class="horizontal-line"></div>
      <div class="vertical-line"></div>
      <div class="bottom-horizontal-line"></div>
      <div class="bottom-vertical-line"></div>
      <div class="mb-3 pl-[45px]">
        <div class="flex items-center mb-4">
          <span class="mr-2">
            <img src="../../../assets/Container.svg" alt="">
          </span>

        </div>
        <p class="text-sm mb-1">
          Circularity is a sustainable brand focused on selling high-quality used parts and scrap materials. We promote
          reuse to reduce waste and offer cost-effective solutions.
        </p>
        <p class="text-sm">
          Join us in creating a circular economy where every part has a purpose!
        </p>
      </div>
      <div class="mb-4 mt-3 pl-[45px]">
        <h3 class="text-lg font-semibold mb-1">General</h3>
        <div class="flex flex-wrap items-center space-x-2 text-sm">
          <a href="/home" class="hover:underline cursor-pointer">Home</a>
      
          <span>|</span>
          <a href="/product-list" (click)="gotoproductList('Used Parts')" class="hover:underline cursor-pointer">Used Parts</a>
          <span>|</span>
          <a href="/product-list" (click)="gotoproductList('Scrap Part')" class="hover:underline cursor-pointer">Scrap</a>
        </div>
      </div>
      <div class="mb-4 mt-3 pl-[45px]">
        <h3 class="text-lg font-semibold mb-1">Other Links</h3>
        <div class="flex flex-wrap items-center space-x-2 text-sm">
       
          <a href="/blog-stories" class="hover:underline cursor-pointer">Blogs & Videos</a>
          <span>|</span>
          <!-- <a href="/contact-us" class="hover:underline cursor-pointer">Contact us</a>
          <span>|</span> -->
          <a href="/user-profile/profile-faq" class="hover:underline cursor-pointer">FAQ's</a>
          <span>|</span>
          <a href="/user-profile/customer-support" class="hover:underline cursor-pointer">Customer Support</a>
        </div>
      </div>
      <div class="mb-4 mt-3 pl-[45px]">
        <h3 class="text-lg font-semibold mb-1">Policies</h3>
        <div class="flex flex-wrap items-center space-x-2 text-sm">
          <a href="/terms-condition" class="hover:underline cursor-pointer">Terms & Conditions</a>
          <span>|</span>
          <a (click)="navigateToRefundPolicy()" class="hover:underline cursor-pointer">Refund Policy</a>
          <span>|</span>
          <a href="/privacy-policy" class="hover:underline cursor-pointer">Privacy Policy</a>
        </div>
      </div>
      <div class="mb-4 mt-3 pl-[45px]">
        <h3 class="text-lg font-semibold mb-1">Follow us</h3>
        <div class="flex items-center space-x-2 sm:space-x-8 mt-2">
          <a href="#" class="hover:text-gray-300 cursor-pointer">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 sm:h-7 sm:w-7" fill="currentColor" viewBox="0 0 24 24">
              <path
                d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z" />
            </svg>
          </a>
          <span>|</span>
          <a href="#" class="hover:text-gray-300 cursor-pointer">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 sm:h-7 sm:w-7" fill="currentColor" viewBox="0 0 24 24">
              <path
                d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" />
            </svg>
          </a>
          <span>|</span>
          <a href="#" class="hover:text-gray-300 cursor-pointer">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 sm:h-7 sm:w-7" fill="currentColor" viewBox="0 0 24 24">
              <path
                d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
            </svg>
          </a>
          <span>|</span>
          <a href="#" class="hover:text-gray-300 cursor-pointer">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 sm:h-7 sm:w-7" fill="currentColor" viewBox="0 0 24 24">
              <path
                d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z" />
            </svg>
          </a>
        </div>
      </div>
      <div class="border-t my-6 border-black ml-[45px]"></div>
      <div class="text-center text-[12px] pl-[45px]">
        <p>&copy; 2023 Circularity. All Rights Reserved by<br />TATA MOTORS PVT. LTD</p>
      </div>
    </div>
  </footer>
</div>

<!-- Desktop Footer (current grid) -->
<div class="hidden md:block">
  <footer class="text-black" style="background-color: #C9DFF7;
;">


    <div class="container relative max-w-[100%]">
      <!-- <svg width="92" height="164" viewBox="0 0 92 164" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M89.5 2V48H55.5V162H2V2H89.5Z" fill="#307FE1" stroke="#307FE1" stroke-width="4"/>
        </svg> -->
        
      <svg xmlns="http://www.w3.org/2000/svg" width="100" height="178" viewBox="0 0 100 178" fill="none" class="t-image">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M64 0H0V56V178H64V56H100V0H64Z" fill="#307FE1" stroke="#307FE1" />
      </svg>
      <div class="horizontal-line"></div>
      <div class="vertical-line"></div>
      <div class="bottom-horizontal-line"></div>
      <div class="bottom-vertical-line"></div>
      <div class="grid grid-cols-1 md:grid-cols-5 gap-4 pt-[70px] pr-0 pb-0 pl-[120px]">
        <!-- Brand Section -->
        <div class="col-span-1">
          <div class="flex items-center mb-4">
            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            class="refresh-icon">
            <g clip-path="url(#clip0_122_27597)">
              <path
                d="M3.50153 9.51515C4.87377 4.39387 10.1378 1.35468 15.2591 2.72692C18.6914 3.6466 21.1884 6.31434 22.0491 9.51563M3.50153 9.51515L1.80447 6.57576M3.50153 9.51515L6.86518 8.55294M22.0473 14.4845C20.6751 19.6057 15.411 22.6449 10.2898 21.2727C6.85748 20.353 4.3604 17.6853 3.5 14.484M22.0473 14.4845L23.7444 17.4239M22.0473 14.4845L18.6837 15.4467"
                stroke="#0A0A5F" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
            </g>
            <text x="6" y="18" fill="#0A0A5F" font-size="18" font-family="Arial, sans-serif">C</text>
    
            <defs>
              <clipPath id="clip0_122_27597">
                <rect width="24" height="24" fill="white" transform="translate(0.5)"></rect>
              </clipPath>
            </defs>
          </svg>
          <span class="text-sm tracking-widest text-blue-950">IRCULARITY</span>
          </div>
          <p class="text-sm mb-4">
            Circularity is a sustainable brand focused on selling high-quality used parts and scrap materials. We
            promote reuse to reduce waste and offer cost-effective solutions.
          </p>
          <p class="text-sm">
            Join us in creating a circular economy where every part has a purpose!
          </p>
        </div>
        <!-- General Links -->
        <div class="col-span-1">
          <h3 class="text-lg font-semibold mb-4">General</h3>
          <ul class="space-y-2">
            <li><a href="/home" class="hover:underline cursor-pointer">Home</a></li>            
            <li><a (click)="gotoproductList('Used Parts')" class="hover:underline cursor-pointer">Used Parts</a></li>
            <li><a (click)="gotoproductList('Scrap Part')" class="hover:underline cursor-pointer">Scrap</a></li>
          </ul>
        </div>
        <!-- About Links -->
        <div class="col-span-1">
          <h3 class="text-lg font-semibold mb-4">Other Links</h3>
          <ul class="space-y-2">
            <li><a href="/blog-stories" class="hover:underline cursor-pointer">Blogs & Videos</a></li>
            <li><a href="/user-profile/profile-faq" (click)="handleProtectedNavigation($event, '/user-profile/profile-faq')" class="hover:underline cursor-pointer">FAQ's</a></li>
            <li><a href="/user-profile/customer-support" (click)="handleProtectedNavigation($event, '/user-profile/customer-support')" class="hover:underline cursor-pointer">Customer Support</a></li>
          </ul>
        </div>
        <!-- Policies and Social -->
        <div class="col-span-1">
          <h3 class="text-lg font-semibold mb-4">Policies</h3>
          <ul class="space-y-2 mb-6">
            <li><a href="/terms-condition" class="hover:underline cursor-pointer">Terms & Conditions</a></li>
            <li><a (click)="navigateToRefundPolicy()" class="hover:underline cursor-pointer">Refund Policy</a></li>
            <li><a href="/privacy-policy" class="hover:underline cursor-pointer">Privacy Policy</a></li>
          </ul>
        </div>
        <div class="col-span-1">
          <h3 class="text-lg font-semibold mb-4">Follow us</h3>
          <div class="flex space-x-4">
            <a href="#" class="hover:text-gray-300 cursor-pointer">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                <path
                  d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z" />
              </svg>
            </a>
            <a href="#" class="hover:text-gray-300 cursor-pointer">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                <path
                  d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" />
              </svg>
            </a>
            <a href="#" class="hover:text-gray-300 cursor-pointer">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                <path
                  d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
              </svg>
            </a>
            <a href="#" class="hover:text-gray-300 cursor-pointer">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                <path
                  d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
      <div class="border-t my-6 border-black ml-[120px] mt-6"></div>
      <div class="text-center text-sm md:pb-4">
        <p>&copy; 2023 Circularity. All Rights Reserved by TATA MOTORS PVT. LTD</p>
      </div>
    </div>
  </footer>
</div>